import {Injectable} from '@angular/core';
import {HttpHelper} from '../../http-helper';
import {Observable} from 'rxjs';
import {CreateIssueResponse, StoreIssueDto} from '../models/create-issue.model';
import {IssueResponse} from '../models/issue.model';

@Injectable({providedIn: 'root'})
export class IssueService {

  constructor(private httpHelper: HttpHelper) {
  }

  createIssue(data: StoreIssueDto): Observable<CreateIssueResponse> {
    return this.httpHelper.postRequest("/jira/issues", data)
  }

  getIssueById(id: number):Observable<IssueResponse> {
    return this.httpHelper.getRequest("/jira/issues/"+id);
  }
}
